module.exports = __webpack_public_path__ + "public/img/fileicon.695a77d8.png";